<button #originRef (click)="showPopover()" [class.active]="dropdownOpen" matBadge="{{notificationCount}}"  class="button" mat-icon-button type="button">
  <mat-icon [icIcon]="icNotificationsActive"></mat-icon>
</button>
